import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  Stack,
} from '@chakra-ui/react';
import FooterControls from '../../common/FooterControls';
import RangeSelection from './molecules/RangeSelection';
import RuleCriteriaCondition from './molecules/RuleCriteriaCondition';
import RuleInputs from './molecules/RuleInputs';
import Settings from './molecules/Settings';
import useCreateDataValidation from './useCreateDataValidation';

interface DataValidationModalProps {
  sheetId: string;
  onClose: () => void;
}
const CreateValidation: React.FC<DataValidationModalProps> = ({
  sheetId,
  onClose,
}) => {
  const {
    range,
    rule,
    settings,
    updateSettings,
    setRange,
    changeCriteria,
    updateRule,
    saveRule,
  } = useCreateDataValidation(onClose, sheetId);

  return (
    <Modal onClose={onClose} isOpen={true} isCentered size="xl">
      <ModalContent rounded="2xl">
        <ModalHeader>Data Validation</ModalHeader>
        <ModalCloseButton />

        <Stack spacing="2" padding="0px 20px">
          <RangeSelection range={range} setRange={setRange} />

          <RuleCriteriaCondition
            rule={rule}
            changeCriteria={changeCriteria}
            updateRule={updateRule}
          />

          <RuleInputs rule={rule} updateRule={updateRule} />

          <Settings settings={settings} updateSettings={updateSettings} />
        </Stack>

        {/* <Stack spacing="2" padding="10px 20px">
          <HStack>
            {getDeliverySet().map(({ Icon, value }) => (
              <IconButton
                isRound
                key={value}
                icon={<Icon />}
                aria-label={value}
              />
            ))}
          </HStack>
          <HStack>
            {getPaymentInflowSet().map(({ Icon, value }) => (
              <IconButton
                isRound
                key={value}
                icon={<Icon />}
                aria-label={value}
              />
            ))}
          </HStack>
          <HStack>
            {getPrioritySet().map(({ Icon, value }) => (
              <IconButton
                isRound
                key={value}
                icon={<Icon />}
                aria-label={value}
              />
            ))}
          </HStack>
        </Stack> */}

        <FooterControls onApply={saveRule} />
      </ModalContent>
    </Modal>
  );
};

export default CreateValidation;
